import React, { Dispatch, SetStateAction } from 'react';
import { ColorPalette, DefaultPalette } from './ColorPalette';
import ColorSwatch from './ColorSwatch';
import ColorSwatchList from './ColorSwatchList';
import { SelectedColorState } from './PalettePage';

export interface ColorSwatchSectionProps {
  paletteState: ColorPalette;
  setPaletteState: (palette: ColorPalette) => void;
  selectedColorState: SelectedColorState;
  setSelectedColorState: Dispatch<SetStateAction<SelectedColorState>>;
}

export const ColorSwatchSection: React.FC<ColorSwatchSectionProps> = ({
  paletteState,
  setPaletteState,
  selectedColorState,
  setSelectedColorState,
}) => {
  return (
    <div className="gap-8 flex flex-col">
      <ColorSwatchList
        title="Primary colors"
        reset={() =>
          setPaletteState({ ...paletteState, primaryScale: DefaultPalette.primaryScale })
        }
      >
        {[0, 1, 2].map((color, index) => (
          <ColorSwatch
            setOpen={() => setSelectedColorState({ colorKey: 'primaryScale', colorIndex: index })}
            key={color}
            color={paletteState.primaryScale[color]}
            open={
              selectedColorState.colorKey === 'primaryScale' &&
              selectedColorState.colorIndex === index
            }
          />
        ))}
      </ColorSwatchList>

      <ColorSwatchList
        title="Secondary colors"
        reset={() =>
          setPaletteState({ ...paletteState, secondaryScale: DefaultPalette.secondaryScale })
        }
      >
        {[0, 1, 2].map((color, index) => (
          <ColorSwatch
            setOpen={() => setSelectedColorState({ colorKey: 'secondaryScale', colorIndex: index })}
            key={color}
            color={paletteState.secondaryScale[color]}
            open={
              selectedColorState.colorKey === 'secondaryScale' &&
              selectedColorState.colorIndex === index
            }
          />
        ))}
      </ColorSwatchList>

      <ColorSwatchList
        title="Tertiary colors"
        reset={() =>
          setPaletteState({ ...paletteState, tertiaryScale: DefaultPalette.tertiaryScale })
        }
      >
        {[0, 1, 2].map((color, index) => (
          <ColorSwatch
            setOpen={() => setSelectedColorState({ colorKey: 'tertiaryScale', colorIndex: index })}
            key={color}
            color={paletteState.tertiaryScale[color]}
            open={
              selectedColorState.colorKey === 'tertiaryScale' &&
              selectedColorState.colorIndex === index
            }
          />
        ))}
      </ColorSwatchList>
      <ColorSwatchList
        title="Performance colors"
        reset={() =>
          setPaletteState({
            ...paletteState,
            performanceScale: DefaultPalette.performanceScale,
          })
        }
      >
        {[0, 1, 2, 3, 4, 5].map((color, index) => (
          <ColorSwatch
            setOpen={() =>
              setSelectedColorState({ colorKey: 'performanceScale', colorIndex: index })
            }
            key={color}
            color={paletteState.performanceScale[color]}
            open={
              selectedColorState.colorKey === 'performanceScale' &&
              selectedColorState.colorIndex === index
            }
          />
        ))}
      </ColorSwatchList>
    </div>
  );
};

export default ColorSwatchSection;
